import { render, staticRenderFns } from "./Direct-Contact.vue?vue&type=template&id=471fcc12&scoped=true"
import script from "./Direct-Contact.vue?vue&type=script&lang=js"
export * from "./Direct-Contact.vue?vue&type=script&lang=js"
import style0 from "./Direct-Contact.vue?vue&type=style&index=0&id=471fcc12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471fcc12",
  null
  
)

export default component.exports